var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGraduationCap = function SvgGraduationCap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#02A6BD"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m44.123 25.96-14.23 4.384q-.31.103-.671.154a5.1 5.1 0 0 1-1.444 0 4.6 4.6 0 0 1-.696-.154h.026L16.77 27.147q-.336.465-.465.928a4.7 4.7 0 0 0-.154 1.057q.36.233.58.606.219.375.219.812 0 .465-.232.838-.232.374-.619.606l.851 6.342a.38.38 0 0 1-.103.322.4.4 0 0 1-.31.142h-2.474a.4.4 0 0 1-.31-.142.38.38 0 0 1-.103-.322l.85-6.342a1.8 1.8 0 0 1-.618-.606 1.56 1.56 0 0 1-.232-.838q0-.465.232-.85.232-.388.619-.594.026-.696.167-1.302t.452-1.147l-2.243-.696Q12 25.703 12 24.775t.877-1.186l14.23-4.383q.31-.103.671-.154a5.1 5.1 0 0 1 1.444 0q.36.05.696.154h-.026l14.231 4.383q.877.258.877 1.186t-.877 1.186m-17.495 5.966q.447.122.905.197.477.077.967.077t.967-.064.89-.194l.025-.026 7.786-2.397.645 4.331q0 .696-.8 1.29-.825.591-2.217 1.043t-3.274.71a30 30 0 0 1-4.022.257 30 30 0 0 1-4.022-.258q-1.882-.258-3.274-.709t-2.217-1.044q-.8-.593-.8-1.289l.645-4.331 7.786 2.397z"
  }))));
};
export default SvgGraduationCap;